import Vue from "vue";
import variables from "./variables.js";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Home from "./views/Home.vue";
import Programma from "./views/Programma.vue";
import Archief from "./views/Archief.vue";
import EditieArchief from "./views/EditieArchief.vue";
import Talk from "./views/Talk.vue";
import Info from "./views/Info.vue";
import Article from "./views/Article.vue";
import ArticleIndex from "./views/ArticleIndex.vue";
import PrivacyStatement from "./views/PrivacyStatement.vue";
import VirtualVenue from "./views/VirtualVenue.vue";

Vue.use(Router);

export default new Router({
  linkExactActiveClass: "active",
  mode: 'history',
  routes: [
    {
      path: "/",
      name: "Home",
      components: {
        header: AppHeader,
        default: Home,
        footer: AppFooter
      }
    },
    {
      path: "/virtual-venue",
      name: "Virtual Venue",
      components: {
        header: AppHeader,
        default: VirtualVenue,
        footer: AppFooter
      }
    },
    {
      path: "/programma/:year?/:id?",
      name: "Programma",
      components: {
        header: AppHeader,
        default: Programma,
        footer: AppFooter
      }
    },
    {
      path: "/article/:index",
      name: "Article",
      components: {
        header: AppHeader,
        default: Article,
        footer: AppFooter
      }
    },
    {
      path: "/article",
      name: "News",
      components: {
        header: AppHeader,
        default: ArticleIndex,
        footer: AppFooter
      }
    },
    {
      path: "/archief",
      name: "Archief",
      components: {
        header: AppHeader,
        default: Archief
      }
    },
    {
      path: "/archief/:year",
      name: "Editie",
      components: {
        header: AppHeader,
        default: EditieArchief,
        footer: AppFooter
      }
    },
    {
      path: "/talk/:year/:id",
      name: "Talk",
      components: {
        header: AppHeader,
        default: Talk,
        footer: AppFooter
      }
    },
    {
      path: "/privacy",
      name: "Privacy",
      components: {
        header: AppHeader,
        default: PrivacyStatement,
        footer: AppFooter
      }
    },
    {
      path: "/notes",
      name: "Notes",
      components: {
        header: AppHeader,
        default: Info,
        footer: AppFooter
      }
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
